module.exports = __webpack_public_path__ + "static/media/04_kazehaya20ce46a01c6d4658535f587666c46aeb.webp";